/**
 * @param {string} fileName
 * @returns {string}
 */
function parseLocaleNameFromFilename(fileName) {
  const [, localeName] = fileName.match(/([A-Za-z0-9-_]+)\.json$/i);
  return localeName;
}

/**
 * @param {__WebpackModuleApi.RequireContext} requireContext Return value of require.context() call
 * @param {import("client/../node_modules/vue-i18n/types/index").IVueI18n} i18n VueI18n instance
 */
export function createLocaleLoader(requireContext, i18n) {
  const cache = {};

  /**
   * Loads the active/fallback locales and merges them into the vue-i18n message tree
   * @param {__WebpackModuleApi.RequireContext} context
   */
  function loadLocales(context) {
    const promises = context
      .keys()
      .map((fileName) => ({
        fileName,
        localeName: parseLocaleNameFromFilename(fileName),
      }))
      .filter(({ localeName }) => localeName === i18n.locale || localeName === i18n.fallbackLocale)
      .map(async ({ fileName, localeName }) => {
        const localeModule = await context(fileName);

        if (cache[fileName] === localeModule) {
          return;
        }

        cache[fileName] = localeModule;
        i18n.mergeLocaleMessage(localeName, localeModule);
      });

    return Promise.all(promises);
  }

  // vue-i18n runs a Vue instance under the hood for reactivity
  // we can watch for changes to the active locale and automatically load
  // the new language when it changes

  // disabling eslint for this line because we do not control the `_vm` property name
  // eslint-disable-next-line no-underscore-dangle
  i18n._vm.$watch('locale', () => loadLocales(requireContext));

  return loadLocales;
}

export default {
  createLocaleLoader,
};
